(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.oval = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.oval = oval;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function oval(svg) {
    return _react2.default.createElement("svg", {
      width: svg.width,
      height: svg.height,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: svg.color
    }, _react2.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, _react2.default.createElement("g", {
      transform: "translate(1 1)",
      strokeWidth: "2"
    }, _react2.default.createElement("circle", {
      strokeOpacity: ".5",
      cx: "18",
      cy: "18",
      r: "18"
    }), _react2.default.createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18"
    }, _react2.default.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "1s",
      repeatCount: "indefinite"
    })))));
  }
});